import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    releaseDate,
    representative,
    date,
    agencyName,
    agencyTax,
    sendTo,
  },
} = checkout;

const validation = Yup.object().shape({
  [sendTo.name]: Yup.string().required(sendTo.errorMsg),
  [conpanyName.name]: Yup.string().required(conpanyName.errorMsg),
  [releaseDate.name]: Yup.string().required(releaseDate.errorMsg),
  [date.name]: Yup.string().required(date.errorMsg),
  [agencyName.name]: Yup.string().required(agencyName.errorMsg),
  [agencyTax.name]: Yup.string().required(agencyTax.errorMsg),
  [representative.name]: Yup.string().required(representative.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
